import { useState, useCallback } from "react";

export function useCountPendingRequests() {
  const [pendingCount, setPendingCount] = useState(0);

  const startRequest = useCallback(() => {
    setPendingCount((prev) => prev + 1);
  }, []);

  const finishRequest = useCallback(() => {
    setPendingCount((prev) => Math.max(prev - 1, 0));
  }, []);

  const isLoading = pendingCount > 0;

  return { pendingCount, isLoading, startRequest, finishRequest };
}
